import { useCallback } from 'react'
import { useStakeholderContext } from '../../../../../features/stakeholder'
import { useOptionalCharacterModal } from '../../../../../context/CharacterModalContext'

interface UseStakeholderLookupResult {
  projectStakeholders: ReturnType<typeof useStakeholderContext>['projectStakeholders']
  characterModal: ReturnType<typeof useOptionalCharacterModal>
  getStakeholderPortraitUrl: (name: string) => string | null
  getStakeholderTemplateId: (name: string) => string | undefined
  handleAvatarClick: (templateId?: string) => void
}

export function useStakeholderLookup(): UseStakeholderLookupResult {
  const { projectStakeholders } = useStakeholderContext()
  const characterModal = useOptionalCharacterModal()

  const getStakeholderPortraitUrl = useCallback(
    (name: string): string | null => {
      const stakeholder = projectStakeholders.find((s) => s.template?.name === name)
      return stakeholder?.template?.portrait_url ?? null
    },
    [projectStakeholders]
  )

  const getStakeholderTemplateId = useCallback(
    (name: string): string | undefined => {
      const stakeholder = projectStakeholders.find((s) => s.template?.name === name)
      return stakeholder?.template?.id
    },
    [projectStakeholders]
  )

  const handleAvatarClick = useCallback(
    (templateId?: string) => {
      if (characterModal && templateId) {
        characterModal.openModal(templateId)
      }
    },
    [characterModal]
  )

  return {
    projectStakeholders,
    characterModal,
    getStakeholderPortraitUrl,
    getStakeholderTemplateId,
    handleAvatarClick,
  }
}
